import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/_auth/product/$productId/_layout/forecast")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/product/$productId/demand",
      params: { productId: params.productId },
    })
  },
})
